import rotas from '../components/RotasMenu'

const routeToModuleMap = {}

Object.entries(rotas).forEach(([modulo, rotasModulo]) => {
    Object.keys(rotasModulo).forEach(rota => {
        routeToModuleMap[rota] = modulo
    })
})

export const getModuleFromRoute = (pathname) => {
    let retorno = 'base'
    const cleanPath = pathname.split('?')[0].split('#')[0]
    
    if (routeToModuleMap[cleanPath]) {
        retorno = routeToModuleMap[cleanPath]
    }
    
    for (const [route, module] of Object.entries(routeToModuleMap)) {
        if (cleanPath.startsWith(route)) {
            retorno = module
        }
    }
    
    const menu = JSON.parse(localStorage.getItem('__hidroview__me')).menu
    const menuItems = menu.map(item => item.item)
    if (!menuItems.includes(retorno)) {
        retorno = 'base'
    }

    saveModuleToStorage(retorno)
    return retorno
}

export const determineInitialModule = (currentPath, fallbackModule = 'base') => {
    const routeModule = getModuleFromRoute(currentPath)

    const finalModule = routeModule !== 'base' ? routeModule : fallbackModule

    return finalModule
}

export const saveModuleToStorage = (moduleName) => {
    localStorage.setItem('currentModule', moduleName)
}